import classNames from 'classnames/bind';
import {
  FilterKeys,
  InternationalFilterContext,
} from 'contexts/internationalFilter';
import { useContext } from 'react';
import FilterSet from './filterSet';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IAlliance {
  nameKr: string;
  nameEn: string;
  clickCode: string;
  airlines: Set<string>;
}

const allianceList: IAlliance[] = [
  {
    nameKr: '스타 얼라이언스',
    nameEn: 'Star Alliance',
    clickCode: 'ift.alstar',
    airlines: new Set([
      'UA',
      'LH',
      'AC',
      'SK',
      'TG',
      'NZ',
      'NH',
      'OS',
      'SQ',
      'OZ',
      'LO',
      'OU',
      'TP',
      'LX',
      'SA',
      'CA',
      'TK',
      'MS',
      'SN',
      'A3',
      'ET',
      'AV',
      'TA',
      'T0',
      'LR',
      'CM',
      'BR',
      'ZH',
      'AI',
    ]),
  },
  {
    nameKr: '스카이팀',
    nameEn: 'Sky Team',
    clickCode: 'ift.alsky',
    airlines: new Set([
      'AF',
      'DL',
      'OK',
      'KL',
      'UX',
      'AM',
      'KE',
      'AZ',
      'SU',
      'KQ',
      'VN',
      'RO',
      'MU',
      'FM',
      'CI',
      'SV',
      'ME',
      'AR',
      'MF',
      'GA',
    ]),
  },
  {
    nameKr: '원월드',
    nameEn: 'One World',
    clickCode: 'ift.aloneworld',
    airlines: new Set([
      'AA',
      'BA',
      'IB',
      'LA',
      'AY',
      'CX',
      'QF',
      'LP',
      'JL',
      'RJ',
      'XL',
      '4M',
      'KA',
      'S7',
      'MH',
      'QR',
      'JJ',
      'UL',
    ]),
  },
];

interface IProps {
  airlineFilter: FilterSet<string>;
}

export default function AllianceFilter({ airlineFilter }: IProps) {
  const { filterState, setFilterStates } = useContext(
    InternationalFilterContext,
  );
  const [allianceSelected, airlineSelected] = [
    filterState[FilterKeys.alliance],
    filterState[FilterKeys.airline],
  ];
  const onSelected = (idx: number) => {
    const allianceState = [...allianceSelected];
    // 첫 얼라이언스 버튼 클릭시 이전 선택된 항공사는 리셋
    if (allianceState.every(el => el === false)) {
      airlineSelected.clear();
    }
    const newVal = !allianceState[idx];
    allianceState[idx] = newVal;

    const airlines = Array.from(allianceList[idx].airlines.values());
    const airlineState = new Set<string>(airlineSelected);
    airlineFilter.items.forEach(item => {
      if (airlines.includes(item.value)) {
        if (newVal) {
          if (!airlineState.has(item.value)) {
            airlineState.add(item.value);
          }
        } else {
          airlineState.delete(item.value);
        }
      }
    });
    setFilterStates({
      [FilterKeys.airline]: airlineState,
      [FilterKeys.alliance]: allianceState,
    });
  };
  return (
    <>
      {allianceList.map(
        ({ nameKr, nameEn, clickCode }: IAlliance, index: number) => (
          <button
            type="button"
            key={`alliance${index}`}
            className={cx('AllianceFilter')}
            role="checkbox"
            data-block="false"
            data-shape="round"
            aria-checked={allianceSelected[index]}
            data-event-nlog="click"
            data-event-area-code={clickCode}
            onClick={() => onSelected(index)}
          >
            <i className={cx('name')}>{`${nameKr} (${nameEn})`}</i>
          </button>
        ),
      )}
    </>
  );
}
